import loggerRegistry from 'ia-react-core/~/services/log/loggerRegistry';
import LOG_LEVELS from '../../constants/LOG_LEVELS';

import log from './_log';
import consoleReporter from './_consoleReporter';
import setLoggerApi from './_setLoggerApi';

setLoggerApi();

type LogLevel = Lowercase<keyof typeof LOG_LEVELS>;

export interface LoggerReporter {
  (namespace: string, level: LogLevel, ...args: unknown[]): void;
}

export type Logger = Record<LogLevel, (...args: unknown[]) => void> & {
  reporters?: LoggerReporter[];
};

export interface CreateLoggerOptions {
  namespace?: string;
  reporters?: LoggerReporter[];
}

const createLogger = ({ namespace = 'App', reporters = [consoleReporter] }: CreateLoggerOptions = {}) => {
  if (process.env.REACT_APP_STYLEGUIDE !== 'true' && loggerRegistry[namespace]) {
    throw new Error('A logger has already been created for this namespace. To retreive an existing logger, use the "getLogger" util.');
  }

  const levels = Object.keys(LOG_LEVELS) as (keyof typeof LOG_LEVELS)[];

  const logger: Logger = Object.assign(
    levels.reduce((result: Logger, LEVEL) => {
      const level = LEVEL.toLowerCase() as Lowercase<keyof typeof LOG_LEVELS>;

      result[level] = (...args: unknown[]) => log(namespace, level, logger.reporters, ...args);

      return result;
    }, {} as Logger),
    {
      reporters,
    },
  );

  loggerRegistry[namespace] = logger;

  return logger;
};

/**
 * @component
 * @visibleName createLogger
 */
export default createLogger;
